import { Gradient } from '@components/Modal';
import { Heading } from '@fastly/consistently';
import * as React from 'react';
import styled from 'styled-components';

export const GradientHeading = styled.h1`
  display: inline-block;
  font: ${({ small }: { small?: boolean }) => (small ? 'var(--h3)' : 'var(--h1)')};
  color: var(--color-gradient-end);
  letter-spacing: -0.01em;

  @supports (-webkit-background-clip: text) {
    color: transparent;
    background: linear-gradient(120deg, var(--color-gradient-start) 10%, var(--color-gradient-end) 90%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  // TODO: use the gradient from Modal
  /* ${Gradient} */
`;

type HeadingProps = {
  as?: string;
};

export const SectionHeading: React.FC<HeadingProps> = ({ as = 'h3', children }) => (
  <Heading level={as} size={'h1'} letterSpacing={'-0.01em'}>
    {children}
  </Heading>
);

type EventHeadingProps = {
  as?: string;
  live?: boolean;
};

export const EventHeading: React.FC<EventHeadingProps> = ({ as = 'h5', live, children }) => (
  <Heading level={as} size={'h3'} color={live ? 'color-blue' : 'color-text-muted'}>
    {children}
  </Heading>
);

const textVariants = {
  light: {
    default: 'text',
    muted: 'text-muted',
  },
  dark: {
    default: 'dark-text',
    muted: 'dark-text-muted',
  },
};

const weights = {
  light: 300,
  normal: 400,
  bold: 700,
};

type TextProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  mode?: keyof typeof textVariants;
  variant?: keyof typeof textVariants.light;
  weight?: keyof typeof weights;
};

export const Text = styled.span<TextProps>`
  font: ${({ size = 'md' }) => `var(--text-${size})`};
  color: ${({ mode = 'light', variant = 'default' }) => `var(--color-${textVariants[mode][variant]})`};
  font-weight: ${({ weight }) => weight && weights[weight]};
`;

const StyledLink = styled(Text)`
  color: var(--color-link);
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

type LinkProps = {
  href: string;
};

export const Link: React.FC<LinkProps> = ({ href, children }) => (
  <StyledLink as="a" href={href} size="sm">
    {children}
  </StyledLink>
);
